module.exports = __webpack_public_path__ + "media/images/flags/dz-e749e3b0c5ac8ee73828c6dc5fc69624.svg";